// // src/app/modules/Members/pages/components/InviteMembersModal.jsx
// // Updated with Staff Support

// import React, { useState, useRef, useEffect } from 'react';
// import { Modal } from 'react-bootstrap';
// import { useDispatch } from 'react-redux';
// import * as actions from '../../../Dashbord/_redux/dashboard/Actions';
// import { useOrgConfig } from '../../../../../hooks/useOrgConfig';
// import { X, UserPlus, User, Shield, Lock, ShieldCheck, Building2, Hash } from 'lucide-react';
// import './InviteMembersModal.scss';

// export function InviteMembersModal({ show, onHide, organizationId, onSuccess }) {
//   const dispatch = useDispatch();
//   const { hasFeature, getLabel } = useOrgConfig();
  
//   const [loading, setLoading] = useState(false);
//   const [memberType, setMemberType] = useState('security');
//   const [emailText, setEmailText] = useState('');
//   const [inviteResults, setInviteResults] = useState(null);
  
//   // 🎯 STAFF FIELDS
//   const [spaceId, setSpaceId] = useState(''); // For staff - which space/department
//   const [staffRole, setStaffRole] = useState('');
//   const [employeeIdPrefix, setEmployeeIdPrefix] = useState('');
  
//   // 🎯 FETCH SPACES
//   const [spaces, setSpaces] = useState([]);
//   const [spacesLoading, setSpacesLoading] = useState(false);
  
//   const isMountedRef = useRef(true);

//   useEffect(() => {
//     isMountedRef.current = true;
//     return () => {
//       isMountedRef.current = false;
//     };
//   }, []);

//   useEffect(() => {
//     if (!show) {
//       resetForm();
//     } else if (show && organizationId) {
//       fetchSpaces();
//     }
//   }, [show, organizationId]);

//   // 🎯 FETCH SPACES FOR DROPDOWN
//   async function fetchSpaces() {
//     if (!organizationId) return;
    
//     setSpacesLoading(true);
//     try {
//       const data = await dispatch(actions.fetchAllData('spaces', organizationId));
//       console.log(data);
//       if (isMountedRef.current) {
//         setSpaces(data.results || data || []);
//       }
//     } catch (error) {
//       console.error('Error fetching spaces:', error);
//     } finally {
//       if (isMountedRef.current) {
//         setSpacesLoading(false);
//       }
//     }
//   }

//   function resetForm() {
//     setMemberType('security');
//     setEmailText('');
//     setInviteResults(null);
//     setLoading(false);
//     setSpaceId('');
//     setStaffRole('');
//     setEmployeeIdPrefix('');
//   }

//   function parseEmails(text) {
//     // Extract emails from text (comma, semicolon, newline separated)
//     const emailRegex = /[^\s@]+@[^\s@]+\.[^\s@]+/g;
//     const matches = text.match(emailRegex);
    
//     if (!matches) return [];
    
//     // Remove duplicates
//     return [...new Set(matches.map(email => email.trim().toLowerCase()))];
//   }

//   async function handleSubmit(e) {
//     e.preventDefault();
    
//     if (!isMountedRef.current) return;
    
//     const emails = parseEmails(emailText);
    
//     if (emails.length === 0) {
//       alert('Please enter at least one valid email address');
//       return;
//     }

//     // 🎯 Validate staff fields if inviting staff
//     if (isStaffType(memberType)) {
//       if (!spaceId) {
//         alert(`Please select a ${getLabel('space')} for ${getLabel('staff')} members`);
//         return;
//       }
//     }

//     setLoading(true);
//     setInviteResults(null);

//     try {
//       const emailsArray = emailText
//         .split(',')
//         .map(e => e.trim())
//         .filter(e => e);

//       const inviteData = {
//         organization_id: organizationId,
//         emails: emailsArray,
//         member_type: memberType,
//       };

//       // 🎯 Add staff-specific fields
//       if (isStaffType(memberType)) {
//         inviteData.space_id = spaceId; // Space/Department
//         inviteData.staff_role = staffRole || memberType; // Use memberType as fallback
//         if (employeeIdPrefix) {
//           inviteData.employee_id_prefix = employeeIdPrefix;
//         }
//       }

//       const result = await dispatch(actions.addData('invite_members', inviteData));
      
//       if (isMountedRef.current) {
//         setInviteResults(result);
        
//         // If all successful, close modal after 2 seconds
//         if (result.errors?.length === 0 && result.already_members?.length === 0) {
//           setTimeout(() => {
//             if (isMountedRef.current) {
//               onHide();
//               if (onSuccess) onSuccess();
//             }
//           }, 2000);
//         }
//       }
//     } catch (error) {
//       console.error('Error inviting members:', error);
//     } finally {
//       if (isMountedRef.current) {
//         setLoading(false);
//       }
//     }
//   }

//   // 🎯 Check if member type is staff
//   function isStaffType(type) {
//     // return type === 'security' || type === 'staff';
//     return type === 'staff';
//   }

//   // 🎯 Build member type options based on org features
//   const memberTypeOptions = [
//     // {
//     //   value: 'user',
//     //   label: 'User',
//     //   icon: User,
//     //   color: '#3699FF',
//     //   description: 'Standard team member',
//     // },
//     // Show staff option if org has staff feature
//      ...(hasFeature('hasResident') ? [{
//       value: 'staff',
//       label: getLabel('residents'),
//       icon: ShieldCheck,
//       color: '#1BC5BD',
//       description: '',
//     }] : []),
//     ...(hasFeature('hasStaff') ? [{
//       value: 'staff',
//       label: getLabel('staff'),
//       icon: ShieldCheck,
//       color: '#1BC5BD',
//       description: 'Store/operational staff',
//     }] : []),
//     {
//       value: 'security',
//       label: 'Security',
//       icon: Lock,
//       color: '#FFA800',
//       description: 'Security personnel',
//     },
//     {
//       value: 'admin',
//       label: 'Admin',
//       icon: Shield,
//       color: '#F64E60',
//       description: 'Full system access',
//     },
//   ];

//   const emailCount = parseEmails(emailText).length;

//   return (
//     <Modal 
//       show={show} 
//       onHide={onHide} 
//       centered 
//       size="lg"
//       className="invite-members-modal"
//       backdrop={loading ? "static" : true}
//     >
//       <form onSubmit={handleSubmit}>
//         <div className="modal-header">
//           <h5 className="modal-title">Invite Team Members</h5>
//           <button 
//             type="button" 
//             className="close" 
//             onClick={onHide} 
//             disabled={loading}
//             aria-label="Close"
//           >
//             <span aria-hidden="true">&times;</span>
//           </button>
//         </div>

//         <div className="modal-body">
//           {!inviteResults ? (
//             <>
//               {/* Member Type Selection */}
//               <div className="form-group">
//                 <label className="form-label">Member Type</label>
//                 <div className="member-type-selector">
//                   {memberTypeOptions.map((option) => {
//                     const Icon = option.icon;
//                     return (
//                       <button
//                         key={option.value}
//                         type="button"
//                         className={`type-btn ${memberType === option.value ? 'active' : ''}`}
//                         onClick={() => setMemberType(option.value)}
//                         disabled={loading}
//                       >
//                         <div className="type-btn-content">
//                           <Icon size={20} style={{ color: option.color }} />
//                           <span className="type-label">{option.label}</span>
//                         </div>
//                         <small className="type-description">{option.description}</small>
//                       </button>
//                     );
//                   })}
//                 </div>
//               </div>

//               {/* 🎯 STAFF FIELDS - Only show for staff/security */}
//               {isStaffType(memberType) && (
//                 <div className="staff-fields">
//                   <h6 className="section-title">
//                     <Building2 size={16} />
//                     {getLabel('staff')} Details
//                   </h6>
                  
//                   <div className="row">
//                     <div className="col-md-6">
//                       <div className="form-group">
//                         <label className="form-label"> 
//                           {getLabel('spaces')} <span className="text-danger">*</span>
//                         </label>
//                         <select
//                           className="form-control"
//                           value={spaceId}
//                           onChange={(e) => setSpaceId(e.target.value)}
//                           disabled={loading || spacesLoading}
//                           required
//                         >
//                           <option value="">
//                             {spacesLoading ? 'Loading...' : `Select ${getLabel('space')}`}
//                           </option>
//                           {spaces.map((space) => (
//                             <option key={space.space_id} value={space.space_id}>
//                               {space.name}
//                             </option>
//                           ))}
//                         </select>
//                         <small className="form-text text-muted">
//                           {memberType === 'staff' ? 'Store department or section' : 'Assigned area'}
//                         </small>
//                       </div>
//                     </div>

//                     <div className="col-md-6">
//                       <div className="form-group">
//                         <label className="form-label">Role/Position</label>
//                         <input
//                           type="text"
//                           className="form-control"
//                           placeholder="e.g. Cashier, Guard, Supervisor"
//                           value={staffRole}
//                           onChange={(e) => setStaffRole(e.target.value)}
//                           disabled={loading}
//                         />
//                         <small className="form-text text-muted">
//                           Optional - defaults to {memberType.toUpperCase()}
//                         </small>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="form-group">
//                     <label className="form-label">
//                       <Hash size={14} />
//                       Employee ID Prefix (Optional)
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="e.g. EMP, STF, SEC"
//                       value={employeeIdPrefix}
//                       onChange={(e) => setEmployeeIdPrefix(e.target.value)}
//                       disabled={loading}
//                       maxLength={10}
//                     />
//                     <small className="form-text text-muted">
//                       Auto-generated IDs will use this prefix (e.g. EMP-001, EMP-002)
//                     </small>
//                   </div>
//                 </div>
//               )}

//               {/* Email Input */}
//               <div className="form-group">
//                 <label className="form-label">
//                   Email Addresses {emailCount > 0 && <span className="text-muted">({emailCount} found)</span>}
//                 </label>
//                 <textarea
//                   className="form-control"
//                   rows="6"
//                   placeholder="Enter email addresses (one per line, comma or semicolon separated)&#10;&#10;example@domain.com&#10;user@company.com, admin@company.com"
//                   value={emailText}
//                   onChange={(e) => setEmailText(e.target.value)}
//                   disabled={loading}
//                 />
//                 <small className="form-text text-muted">
//                   Paste multiple emails or upload a CSV file
//                 </small>
//               </div>

//               {/* File Upload */}
//               <div className="form-group">
//                 <input
//                   type="file"
//                   accept=".csv,.txt"
//                   onChange={(e) => {
//                     const file = e.target.files[0];
//                     if (!file) return;

//                     const reader = new FileReader();
//                     reader.onload = (event) => {
//                       setEmailText(event.target.result);
//                     };
//                     reader.readAsText(file);
//                     e.target.value = '';
//                   }}
//                   className="form-control-file"
//                   id="csv-upload"
//                   disabled={loading}
//                 />
//                 <label htmlFor="csv-upload" className="file-label">
//                   Or choose a CSV/TXT file
//                 </label>
//               </div>
//             </>
//           ) : (
//             // Results Display
//             <div className="invite-results">
//               {inviteResults.invited?.length > 0 && (
//                 <div className="alert alert-success">
//                   <strong>✓ Successfully Invited:</strong> {inviteResults.invited.length}
//                   <div className="mt-2 small">
//                     {inviteResults.invited.slice(0, 5).join(', ')}
//                     {inviteResults.invited.length > 5 && ` and ${inviteResults.invited.length - 5} more`}
//                   </div>
//                   {isStaffType(memberType) && spaceId && (
//                     <div className="mt-2 small text-muted">
//                       {getLabel('space')}: {spaces.find(s => s.space_id === spaceId)?.name}
//                       {staffRole && ` • Role: ${staffRole}`}
//                     </div>
//                   )}
//                 </div>
//               )}

//               {inviteResults.already_members?.length > 0 && (
//                 <div className="alert alert-warning">
//                   <strong>⚠ Already Members:</strong> {inviteResults.already_members.length}
//                   <div className="mt-2 small">
//                     {inviteResults.already_members.slice(0, 5).join(', ')}
//                     {inviteResults.already_members.length > 5 && ` and ${inviteResults.already_members.length - 5} more`}
//                   </div>
//                 </div>
//               )}

//               {inviteResults.errors?.length > 0 && (
//                 <div className="alert alert-danger">
//                   <strong>✗ Failed:</strong> {inviteResults.errors.length}
//                   <div className="mt-2 small">
//                     {inviteResults.errors.slice(0, 3).map((err, idx) => (
//                       <div key={idx}>• {err.email}: {err.error}</div>
//                     ))}
//                     {inviteResults.errors.length > 3 && <div>and {inviteResults.errors.length - 3} more...</div>}
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>

//         <div className="modal-footer">
//           {!inviteResults ? (
//             <>
//               <button 
//                 type="button" 
//                 className="btn btn-light" 
//                 onClick={onHide}
//                 disabled={loading}
//               >
//                 Cancel
//               </button>
//               <button 
//                 type="submit" 
//                 className="btn btn-primary" 
//                 disabled={loading || emailCount === 0}
//               >
//                 {loading ? (
//                   <>
//                     <span className="spinner-border spinner-border-sm mr-2" />
//                     Sending...
//                   </>
//                 ) : (
//                   <>
//                     <UserPlus size={16} className="mr-2" />
//                     Send {emailCount} Invitation{emailCount !== 1 ? 's' : ''}
//                   </>
//                 )}
//               </button>
//             </>
//           ) : (
//             <button 
//               type="button" 
//               className="btn btn-primary" 
//               onClick={() => {
//                 onHide();
//                 if (onSuccess) onSuccess();
//               }}
//             >
//               Done
//             </button>
//           )}
//         </div>
//       </form>
//     </Modal>
//   );
// }








// src/app/modules/Members/pages/components/InviteMembersModal.jsx

import React, { useState, useRef, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import * as actions from '../../../Dashbord/_redux/dashboard/Actions';
import { useOrgConfig } from '../../../../../hooks/useOrgConfig';
import {
  X, UserPlus, User, Shield, Lock, ShieldCheck,
  Building2, Hash, CheckCircle, AlertCircle, XCircle,
  Paperclip,
} from 'lucide-react';
import './InviteMembersModal.scss';

export function InviteMembersModal({ show, onHide, organizationId, onSuccess }) {
  const dispatch = useDispatch();
  const { hasFeature, getLabel } = useOrgConfig();

  const [loading, setLoading]                   = useState(false);
  const [memberType, setMemberType]             = useState(null); // ← no default selection
  const [emailText, setEmailText]               = useState('');
  const [inviteResults, setInviteResults]       = useState(null);
  const [spaceId, setSpaceId]                   = useState('');
  const [staffRole, setStaffRole]               = useState('');
  const [employeeIdPrefix, setEmployeeIdPrefix] = useState('');
  const [spaces, setSpaces]                     = useState([]);
  const [spacesLoading, setSpacesLoading]       = useState(false);

  const isMountedRef = useRef(true);
  const fileInputRef = useRef(null);

  useEffect(() => {
    isMountedRef.current = true;
    return () => { isMountedRef.current = false; };
  }, []);

  useEffect(() => {
    if (!show) {
      resetForm();
    } else if (show && organizationId) {
      fetchSpaces();
    }
  }, [show, organizationId]);

  async function fetchSpaces() {
    if (!organizationId) return;
    setSpacesLoading(true);
    try {
      const data = await dispatch(actions.fetchAllData('spaces', organizationId));
      if (isMountedRef.current) setSpaces(data.results || data || []);
    } catch (e) { console.error(e); }
    finally { if (isMountedRef.current) setSpacesLoading(false); }
  }

  function resetForm() {
    setMemberType(null);
    setEmailText('');
    setInviteResults(null);
    setLoading(false);
    setSpaceId('');
    setStaffRole('');
    setEmployeeIdPrefix('');
  }

  function parseEmails(text) {
    const matches = text.match(/[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+/g);
    if (!matches) return [];
    return [...new Set(matches.map(e => e.trim().toLowerCase()))];
  }

  const emailCount = parseEmails(emailText).length;
  const isStaff    = memberType === 'staff';

  async function handleSubmit(e) {
    e.preventDefault();
    if (!isMountedRef.current || !memberType) return;

    const emails = parseEmails(emailText);
    if (emails.length === 0) return;
    if (isStaff && !spaceId) return;

    setLoading(true);
    setInviteResults(null);

    try {
      const payload = {
        organization_id: organizationId,
        emails: emailText.split(/[\n,;]/).map(e => e.trim()).filter(Boolean),
        member_type: memberType,
        ...(isStaff && {
          space_id:           spaceId,
          staff_role:         staffRole || memberType,
          ...(employeeIdPrefix && { employee_id_prefix: employeeIdPrefix }),
        }),
      };

      const result = await dispatch(actions.addData('invite_members', payload));

      if (isMountedRef.current) {
        setInviteResults(result);
        if (!result.errors?.length && !result.already_members?.length) {
          setTimeout(() => {
            if (isMountedRef.current) { onHide(); onSuccess(); }
          }, 2000);
        }
      }
    } catch (e) { console.error(e); }
    finally { if (isMountedRef.current) setLoading(false); }
  }

  // ── Type options ────────────────────────────────────────────────────────────
  const typeOptions = [
    ...(hasFeature('hasResidents') ? [{
      value: 'user', label: getLabel('residents'),
      icon: ShieldCheck, bg: '#F0FDF4', color: '#16a34a',
      desc: 'Resident access',
    }] : []),
    ...(hasFeature('hasStaff') ? [{
      value: 'staff', label: getLabel('staff'),
      icon: ShieldCheck, bg: '#EFF6FF', color: '#2563EB',
      desc: 'Operational staff',
    }] : []),
    {
      value: 'security', label: 'Security',
      icon: Lock, bg: '#FFFBEB', color: '#D97706',
      desc: 'Security personnel',
    },
    {
      value: 'admin', label: 'Admin',
      icon: Shield, bg: '#FEF2F2', color: '#DC2626',
      desc: 'Full system access',
    },
  ];

  const canSubmit = !loading && !!memberType && emailCount > 0 && (!isStaff || !!spaceId);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      className="invite-members-modal"
      backdrop={loading ? 'static' : true}
    >
      <form onSubmit={handleSubmit}>

        {/* ── Header ──────────────────────────────────────────────────────── */}
        <div className="modal-header">
          <h5 className="modal-title">
            <span className="im-header-icon"><UserPlus size={14} /></span>
            Invite Members
          </h5>
          <button type="button" className="close" onClick={onHide} disabled={loading}>
            <X size={15} />
          </button>
        </div>

        {/* ── Body ────────────────────────────────────────────────────────── */}
        <div className="modal-body">
          {!inviteResults ? (
            <>
              {/* Member Type */}
              <div className="im-section">
                <div className="im-section__title">Member Type</div>
                <div className="im-type-grid">
                  {typeOptions.map((opt) => {
                    const Icon = opt.icon;
                    return (
                      <button
                        key={opt.value}
                        type="button"
                        className={`im-type-btn ${memberType === opt.value ? 'im-type-btn--active' : ''}`}
                        onClick={() => setMemberType(opt.value)}
                        disabled={loading}
                      > 
                        <div
                          className="im-type-btn__icon"
                          style={{ background: opt.bg, color: opt.color }}
                        >
                          <Icon size={16} />
                        </div>
                        <span className="im-type-btn__label" style = {{fontSize: 15}}>{opt.label}</span>
                        <span className="im-type-btn__desc">{opt.desc}</span>
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Staff details — only shown when staff selected */}
              {isStaff && (
                <div className="im-section">
                  {/* <div className="im-section__title">
                    <Building2 size={11} style={{ display: 'inline', marginRight: 4 }} />
                    {getLabel('staff')} Details
                  </div> */}

                  <div className="im-row" style={{ marginBottom: 12 }}>
                    <div className="im-field">
                      <label>
                        <Building2 size={11} />
                        {getLabel('spaces')} <span className="req">*</span>
                      </label>
                      <select
                        value={spaceId}
                        onChange={(e) => setSpaceId(e.target.value)}
                        disabled={loading || spacesLoading}
                        required
                      >
                        <option value="">
                          {spacesLoading ? 'Loading…' : `Select ${getLabel('space')}`}
                        </option>
                        {spaces.map((s) => (
                          <option key={s.space_id} value={s.space_id}>{s.name}</option>
                        ))}
                      </select>
                    </div>

                    <div className="im-field">
                      <label><User size={11} />Role / Position</label>
                      <input
                        type="text"
                        placeholder="e.g. Cashier, Guard, Supervisor"
                        value={staffRole}
                        onChange={(e) => setStaffRole(e.target.value)}
                        disabled={loading}
                      />
                    </div>
                  </div>

                  <div className="im-field">
                    <label><Hash size={11} />Employee ID Prefix <span style={{ color: '#9597A6', fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>(optional)</span></label>
                    <input
                      type="text"
                      placeholder="e.g. EMP, STF, SEC"
                      value={employeeIdPrefix}
                      onChange={(e) => setEmployeeIdPrefix(e.target.value)}
                      disabled={loading}
                      maxLength={10}
                    />
                    <span className="im-field__hint">Auto-generated IDs will use this prefix (e.g. EMP-001)</span>
                  </div>
                </div>
              )}

              {/* Email addresses */}
              <div className="im-section">
                <div className="im-section__title">
                  Email Addresses
                  {emailCount > 0 && (
                    <span className="im-email-count">{emailCount} detected</span>
                  )}
                </div>

                <div className="im-field" style={{ marginBottom: 10 }}>
                  <textarea
                    placeholder={`One email per line, or comma/semicolon separated\n\nalice@company.com\nbob@company.com, carol@company.com`}
                    value={emailText}
                    onChange={(e) => setEmailText(e.target.value)}
                    disabled={loading}
                    rows={5}
                  />
                </div>

                {/* File upload */}
                <div className="im-file-upload" onClick={() => !loading && fileInputRef.current?.click()}>
                  <Paperclip size={14} />
                  <span>Upload a CSV or TXT file</span>
                </div>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".csv,.txt"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    const reader = new FileReader();
                    reader.onload = (ev) => setEmailText(ev.target.result);
                    reader.readAsText(file);
                    e.target.value = '';
                  }}
                  disabled={loading}
                />
              </div>
            </>
          ) : (
            /* Results */
            <div className="im-results">
              {inviteResults.invited?.length > 0 && (
                <div className="im-result-block im-result-block--success">
                  <CheckCircle size={16} className="im-result-block__icon" />
                  <div className="im-result-block__body">
                    <div className="im-result-block__head">
                      <span className="im-result-block__label">Invitations sent</span>
                      <span className="im-result-block__count">{inviteResults.invited.length}</span>
                    </div>
                    <div className="im-result-block__emails">
                      {inviteResults.invited.slice(0, 5).join(', ')}
                      {inviteResults.invited.length > 5 && ` and ${inviteResults.invited.length - 5} more`}
                    </div>
                  </div>
                </div>
              )}

              {inviteResults.already_members?.length > 0 && (
                <div className="im-result-block im-result-block--warning">
                  <AlertCircle size={16} className="im-result-block__icon" />
                  <div className="im-result-block__body">
                    <div className="im-result-block__head">
                      <span className="im-result-block__label">Already members</span>
                      <span className="im-result-block__count">{inviteResults.already_members.length}</span>
                    </div>
                    <div className="im-result-block__emails">
                      {inviteResults.already_members.slice(0, 5).join(', ')}
                      {inviteResults.already_members.length > 5 && ` and ${inviteResults.already_members.length - 5} more`}
                    </div>
                  </div>
                </div>
              )}

              {inviteResults.errors?.length > 0 && (
                <div className="im-result-block im-result-block--danger">
                  <XCircle size={16} className="im-result-block__icon" />
                  <div className="im-result-block__body">
                    <div className="im-result-block__head">
                      <span className="im-result-block__label">Failed</span>
                      <span className="im-result-block__count">{inviteResults.errors.length}</span>
                    </div>
                    <div className="im-result-block__emails">
                      {inviteResults.errors.slice(0, 3).map((err, i) => (
                        <div key={i}>• {err.email}: {err.error}</div>
                      ))}
                      {inviteResults.errors.length > 3 && `and ${inviteResults.errors.length - 3} more…`}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* ── Footer ──────────────────────────────────────────────────────── */}
        <div className="modal-footer">
          {!inviteResults ? (
            <>
              <button type="button" className="btn btn-light" onClick={onHide} disabled={loading}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" disabled={!canSubmit}>
                {loading ? (
                  <><span className="spinner-border spinner-border-sm" />Sending…</>
                ) : (
                  <><UserPlus size={14} />Send {emailCount > 0 ? emailCount : ''} Invite{emailCount !== 1 ? 's' : ''}</>
                )}
              </button>
            </>
          ) : (
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => { onHide(); onSuccess(); }}
            >
              Done
            </button>
          )}
        </div>

      </form>
    </Modal>
  );
}